import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { SearchInput } from '@gem/ui-kit';

import { WorkspaceMembersList } from '../../components/WorkspaceMembersList/WorkspaceMembersList';
import { useNewMessagePopupPresenter } from './NewMessagePopup.presenter';
import styles from './NewMessagePopup.styles.m.css';

export const NewMessagePopup: FC<ICommonPopupsProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useNewMessagePopupPresenter(props);
  useClosePopupOnNavigation(props.popupInstance);

  return (
    <Popup
      isOpened
      title={t('new_message_title')}
      onClose={presenter.onClose}
    >
      <SearchInput
        className={styles.search}
        onChange={presenter.onSearch}
        placeholder={t('main_menu_search_note')}
        value={presenter.searchText}
      />

      <WorkspaceMembersList
        searchText={presenter.searchText}
        isShowMemberMenu={true}
        onMemberClick={presenter.onMemberClick}
      />
    </Popup>
  );
});
